import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { convertPxToRem } from "../../util-functions";
import { Button } from "../Button";
import { StackedNotificationsGraphic } from "./Graphics/StackedNotificationsGraphic";
import { TreezLogo } from "./Graphics/TreezLogo";
const StyledErrorTemplate = styled("div")(() => ({
    width: convertPxToRem(368),
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
}));
const StyledLogoWrapper = styled("div")(({ theme }) => ({
    padding: 0,
    width: "100%",
    minHeight: convertPxToRem(42),
    borderBottom: `1px solid ${theme.palette.treezGrey[5]}`,
    marginBottom: convertPxToRem(80),
    svg: {
        height: convertPxToRem(21),
        marginBottom: convertPxToRem(19),
    },
}));
const StyledGraphicWrapper = styled("div")(() => ({
    display: "flex",
    justifyContent: "center",
    width: convertPxToRem(313),
    marginBottom: convertPxToRem(32),
    height: convertPxToRem(92),
}));
const StyledContentWrapper = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: convertPxToRem(313),
    alignSelf: "center",
}));
const StyledErrorTitle = styled(Typography)(() => ({
    marginBottom: convertPxToRem(8),
}));
const StyledErrorBodyWrapper = styled("div")(({ theme }) => ({
    "> *": Object.assign(Object.assign({ margin: 0, padding: 0 }, theme.typography.mediumText), { textAlign: "center" }),
    marginBottom: convertPxToRem(32),
}));
export const ErrorTemplate = ({ body, buttonProps, hideLogo = false, testId, title, }) => {
    const showButton = buttonProps && Object.keys(buttonProps).length;
    return (_jsxs(StyledErrorTemplate, Object.assign({ "data-testid": testId }, { children: [!hideLogo && (_jsx(StyledLogoWrapper, Object.assign({ "data-testid": testId && `${testId}-logo-wrapper` }, { children: _jsx(TreezLogo, {}) }))), _jsxs(StyledContentWrapper, { children: [_jsx(StyledGraphicWrapper, Object.assign({ "data-testid": testId && `${testId}-graphic-wrapper` }, { children: _jsx(StackedNotificationsGraphic, {}) })), _jsx(StyledErrorTitle, Object.assign({ variant: "h6", "data-testid": testId && `${testId}-error-title` }, { children: title })), body && (_jsx(StyledErrorBodyWrapper, Object.assign({ "data-testid": testId && `${testId}-body-wrapper` }, { children: body }))), showButton && _jsx(Button, Object.assign({}, buttonProps, { variant: "primary" }))] })] })));
};
